import type React from "react";
import Cooking from "@/assets/icons/cooking.svg";
import Mix from "@/assets/icons/mix.svg";
import Reserve from "@/assets/icons/reserve.svg";
import type { MultiDietGuideType } from "@/features/static-builder/types/multidiet-guide.type";

type Props = {
  data: MultiDietGuideType;
  ref: React.RefObject<(HTMLDivElement | null)[]>;
};

export const MultiDietGuideStepsList = ({ data, ref }: Props) => {
  const IconsMap = [Cooking, Mix, Reserve];
  return (
    <>
      {data.guideSteps.map((item, idx) => {
        const Icon = IconsMap[idx];
        return (
          <div
            key={item.id}
            className="flex w-full flex-col gap-4 overflow-hidden rounded-xl bg-brand-green2-300 p-6"
            ref={(el: HTMLDivElement | null) => {
              ref.current[idx] = el;
            }}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 rounded-3xl bg-brand-grey1 px-2 py-[0.4em]">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-green2-300 p-3 text-brand-white">
                  {idx + 1}
                </span>
                <p className="font-medium text-brand-green2-300">
                  {item.label}
                </p>
              </div>
              <Icon className="h-10 w-10" />
            </div>
            <h3 className="title w-[80%] font-medium text-3_5xl text-brand-grey1 leading-10">
              {item.title}
            </h3>
          </div>
        );
      })}
    </>
  );
};
